import { decodeHTML } from 'entities';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { deleteMAGAB020, getMAGAB020 } from '../../../services/Api';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_MENUS, MESSAGE } from '../../../shared/constants/app';

import { ko } from 'date-fns/locale/ko';
import moment from 'moment';
import { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Carousel from '../../../shared/components/Carousel';

registerLocale('ko', ko);

const MAGAB030 = () => {
    const { id } = useParams();
    const [data, setData] = useState([]);
    const [bizImage, setBizImage] = useState([]);
    const formatDate = (date) => (date ? moment(date).locale('ko').format('YYYY.MM.DD') : '');

    useEffect(() => {
        if (id) {
            getMAGAB020(id)
                .then(({ data }) => {
                    setData(data);
                    setBizImage((data?.bizImages ?? '').split(','));
                })
                .catch((error) => console.log(error));
        }
    }, [id]);

    const handleDelete = () => {
        const isConfirm = window.confirm(MESSAGE.confirm.delete);
        if (isConfirm) {
            deleteMAGAB020(id)
                .then(() => {
                    window.alert(MESSAGE.notify.deleteSuccess);
                    window.location.href = '/magab010';
                })
                .catch((error) => console.log(error));
        }
    };

    return (
        <div className="container">
            <div className="wrap">
                <SideMenu menu={MENU_MENUS} />
                <div id="vln" className="vln">
                    <div className="container">
                        <div className="vln-top" style={{ marginBottom: '30px' }}>
                            {bizImage[0] !== '' ? (
                                <div
                                    className="carousel-inner vln-top__img vln-top__imgStyle"
                                    style={{ width: '200px' }}
                                >
                                    <Carousel
                                        dataSlide={(bizImage ? bizImage : []).filter(Boolean)}
                                        dataName="BizImage"
                                    />
                                </div>
                            ) : (
                                <span>{data?.agency}</span>
                            )}
                            <div className="vln-top__info">
                                <h2>{data?.title}</h2>
                            </div>
                            <a className="vln-top__link" href={data?.dentalPage} target="_blank" rel="noreferrer">
                                <img src="./images/icons/icon-homepage.png" alt="icon-home" />
                            </a>
                        </div>
                        <table className="job-table">
                            <tbody>
                                <tr>
                                    <th className="border-t-ddd">공개여부</th>
                                    <td colSpan={3} className="border-t-ddd">
                                        {data?.dspYN === 'Y' ? '공개' : '비공개'}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <h3 className="rsm__sub">모집요강</h3>
                        <table className="job-table">
                            <tbody>
                                <tr>
                                    <th>모집직종</th>
                                    <td>{data?.certificate}</td>
                                </tr>
                                <tr>
                                    <th>모집인원</th>
                                    <td>{data?.numberOfPositions}</td>
                                </tr>
                                <tr>
                                    <th>자격요건</th>
                                    <td>{data?.license}</td>
                                </tr>
                            </tbody>
                        </table>
                        <h3 className="rsm__sub">봉사내용</h3>
                        <table className="job-table">
                            <tbody>
                                <tr>
                                    <th>봉사기간</th>
                                    <td>{data?.period}</td>
                                </tr>
                                <tr>
                                    <th>봉사지역</th>
                                    <td>{data?.jobLocation}</td>
                                </tr>
                                <tr>
                                    <th>봉사활동</th>
                                    <td
                                        dangerouslySetInnerHTML={{
                                            __html: data?.contents ? decodeHTML(data?.contents) : '',
                                        }}
                                    ></td>
                                </tr>
                            </tbody>
                        </table>
                        <h3 className="rsm__sub">모집기간 및 제출사항</h3>
                        <table className="job-table">
                            <tbody>
                                <tr>
                                    <th>모집기간</th>
                                    <td className="blue">
                                        {data?.isIndefinite === 'Y'
                                            ? '상시모집'
                                            : formatDate(data?.startDate) + ' ~ ' + formatDate(data?.endDate)}
                                    </td>
                                </tr>
                                <tr>
                                    <th>지원방법</th>
                                    <td>
                                        {data?.applyMethod
                                            ? data.applyMethod.split('\n').map((line, idx) => (
                                                  <span key={idx}>
                                                      {line}
                                                      {idx !== data.applyMethod.split('\n').length - 1 && <br />}
                                                  </span>
                                              ))
                                            : ''}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <h3 className="rsm__sub">담당자 정보</h3>
                        <table className="job-table">
                            <tbody>
                                <tr>
                                    <th>담당자명</th>
                                    <td>{data?.contactPerson}</td>
                                </tr>
                                <tr>
                                    <th>담당자 연락처</th>
                                    <td>{data?.contactNumber}</td>
                                </tr>
                            </tbody>
                        </table>
                        <h3 className="rsm__sub">모집기관 정보</h3>
                        <table className="job-table">
                            <tbody>
                                <tr>
                                    <th>모집기관</th>
                                    <td
                                        dangerouslySetInnerHTML={{
                                            __html: data?.dentalInfo ? decodeHTML(`${data?.agency}`) : '',
                                        }}
                                    ></td>
                                </tr>
                                <tr>
                                    <th>대표자</th>
                                    <td
                                        dangerouslySetInnerHTML={{
                                            __html: data?.dentalInfo ? decodeHTML(`${data?.dentalOwner}`) : '',
                                        }}
                                    ></td>
                                </tr>
                                <tr>
                                    <th>주소</th>
                                    <td
                                        dangerouslySetInnerHTML={{
                                            __html: data?.dentalInfo ? decodeHTML(`${data?.location}`) : '',
                                        }}
                                    ></td>
                                </tr>
                                <tr>
                                    <th>모집기관 소개</th>
                                    <td
                                        dangerouslySetInnerHTML={{
                                            __html: data?.dentalInfo ? decodeHTML(`${data?.dentalInfo}`) : '',
                                        }}
                                    ></td>
                                </tr>
                                <tr>
                                    <th>기타 세부사항</th>
                                    <td
                                        dangerouslySetInnerHTML={{
                                            __html: data?.infoOther ? decodeHTML(data?.infoOther) : '',
                                        }}
                                    ></td>
                                </tr>
                                <tr>
                                    <th>홈페이지</th>
                                    <td>
                                        <a href={data?.dentalPage} target="_blank" rel="noreferrer">
                                            {data?.dentalPage}
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="bottom-content" style={{ justifyContent: 'start', gap: '15px' }}>
                            <div className="button-form">
                                <Link to={'/magab010'} className="btn btn-primary button-back-to-list">
                                    목록
                                </Link>
                            </div>
                            <div className="button-form">
                                <button
                                    className="btn btn-primary button-back-to-list button-delete"
                                    onClick={() => {
                                        handleDelete();
                                    }}
                                >
                                    삭제
                                </button>
                            </div>
                            <div className="button-form">
                                <Link to={`/magab020-${id}`} className="btn btn-primary button-save">
                                    수정
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default MAGAB030;
